import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    MarkovTransitionProps,
    LoadMarkovTransitionById,
    setMarkovTransitionEdit,
    setMarkovTransitionReloadEdit,
    initMarkovTransition,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"

const Edit = ({
    transitionId = null,
}: MarkovTransitionProps) => {
    const model = useSelector((state: StoreType) => state.markovModel.modelView)

    const transition = useSelector((state: StoreType) => state.markovTransition.transitionEdit)
    const reloadEdit = useSelector((state: StoreType) => state.markovTransition.reloadEdit)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setMarkovTransitionReloadEdit(false))
        setTimeout(() => {
            dispatch(setMarkovTransitionReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        if (transitionId === 0) {
            dispatch(setMarkovTransitionEdit(initMarkovTransition))
            reload()
        } else {
            setLoadState(PENDING)
            LoadMarkovTransitionById(transitionId, model.id).then((res) => {
                dispatch(setMarkovTransitionEdit(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    if (!transition) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{transition.id ? `${lang.editTransition} # ${transition.id}` : lang.addTransition}</PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form transition={transition} />
                }
                {
                    reloadEdit
                    && <Form transition={transition} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
